export default __webpack_public_path__ + "static/platform-use-bg-image-687fc7489b12cdd9788cb10df797e4b4.jpg";